var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",style:({'background-color': _vm.backgroundColor, 'border-left-color': _vm.iconColor})},[_c('span',{staticClass:"title",style:({'color': _vm.fontColor})},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }